// Importado antes de qualquer outro módulo em src/index.js: o patch de fetch
// precisa estar ativo antes que módulos do App disparem requisições no import.
import { installApiEdgeFailover } from './apiEdgeFailover';
import { registerAppShellSw } from './registerAppShellSw';

installApiEdgeFailover();
registerAppShellSw();
